import {useMutation} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {useModal} from "../../../../../hooks";
import {OutgoingCreateType} from "../interface";
import {createOutgoing} from "../../../../../api/inventory/OutgoingApi";
import useGoToNavigation from "../../../../../util/useGotoNavigation";

export const useCreateOutgoing = () => {
    const {handleModal} = useModal();
    const {goToNavigation} = useGoToNavigation()

    const {mutate} = useMutation({
        mutationFn: (data: OutgoingCreateType) => createOutgoing(data),
        onSuccess: (res) => {
            if (res.data.code === "0000") {
                handleModal({
                    isOpen: true,
                    contents: "등록되었습니다.",
                    type: "alert",
                    closeAction: () => {
                        goToNavigation(0, {}, false)
                    }
                });
            } else {
                handleModal({
                    isOpen: true,
                    contents: res.data.msg,
                    type: "alert",
                });
            }
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate};
};
